// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__zHaO-","tab":"ProcedureTabs_tab__21nTK"};